// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap-RaUDxu","title":"title-Rp5kHn","subTitle":"subTitle-ZkO6ih","rightButton":"rightButton-V3ni4S"};